import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import { editCommunityFeedItemCache } from 'src/Services/API/cache';
import { CommunityFeedItemDto, LikeDto } from 'src/Services/API/generated';

export const useCreateCommunityFeedItemLike = (
  options?: UseMutationOptions<LikeDto, unknown, string>
) => {
  const queryClient = useQueryClient();

  return useMutation<LikeDto, unknown, string>(
    'create-community-feed-item-like',
    async (data: string) => {
      const response = await communityFeedApi.communityFeedControllerCreateLike(data);

      return response.data;
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        editCommunityFeedItemCache(queryClient, feedItem => {
          if (feedItem.id !== variables) return feedItem;

          return {
            ...feedItem,
            likes: {
              ...feedItem.likes,
              count: feedItem.likes.count + 1,
              didILike: true,
              firstFive: [...feedItem.likes.firstFive, data].slice(0, 5),
            },
          };
        });

        // optimistic rendering for feed item detail
        const detailQueryKey = ['fetch-community-feed-item', variables];
        const currentItem = queryClient.getQueryData<CommunityFeedItemDto>(detailQueryKey);

        if (currentItem) {
          queryClient.setQueryData<CommunityFeedItemDto>(detailQueryKey, {
            ...currentItem,
            likes: {
              ...currentItem.likes,
              count: currentItem.likes.count + 1,
              didILike: true,
              firstFive: [...currentItem.likes.firstFive, data].slice(0, 5),
            },
          });
        }

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
